import { InjectionToken } from '@angular/core';

export const OUTAGE_PAGE_RELOAD = new InjectionToken<() => void>('OUTAGE_PAGE_RELOAD', {
  providedIn: 'root',
  factory: () => () => globalThis.location.reload(),
});
